import { useEffect } from 'react';
export function useDocumentClass(className, condition) {
  useEffect(() => {
    const html = document.querySelector('html');
    if (condition) {
      html.classList.add(className);
    } else {
      html.classList.remove(className);
    }
  }, [className, condition]);
}